import { StyleSheet, Platform } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: withTray => ({
    flex: 1,
    paddingHorizontal: 16.6,
    paddingTop: Platform.OS === 'ios' ? 17 : 8,
    paddingBottom: withTray ? 120 : 32,
  }),
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    ...cardShadow,
  }),
  addOnsCardStyle: {
    paddingHorizontal: 16.17,
    paddingBottom: 22,
    paddingTop: 10,
    marginBottom: 16,
  },
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  requestedAddOnsContainerStyle: {
    marginTop: 20,
  },
  requestedAddOnsCardStyle: {
    paddingTop: 10,
    paddingBottom: 16,
    paddingRight: 30,
    paddingLeft: 16,
    marginHorizontal: 2,
    marginBottom: 16,
  },
  expiredSubtitleStyle: {
    marginTop: 15,
  },
});
